import React from "react";
import {
  GridFilterForm,
  GridPanelWrapper,
  gridFilterModelSelector,
  gridFilterableColumnDefinitionsSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from "@mui/x-data-grid-premium";

import { FILTER_PANEL_PROPS, FilterPanelBody, type FilterPanelSlotProps } from "./datagrid/filterPanel";

/**
 * A Premium 7.1 grid's Filters panel (`slots.filterPanel`): THE panel, Figma Component 73
 * (datagrid/filterPanel.tsx), fed from this grid's own context. What the grid passes the slot
 * (its `slotProps.filterPanel`) applies on top of the shared defaults. AeronetDataGridPremium
 * sets it; a raw `DataGridPremium` sets it itself.
 *
 * It used to draw its own look — a white form at 45px with a 400px value box over the grey
 * footer (the aircraft Inspections / Components tabs), then the list grids' grey form (A792).
 */
const CustomFilterPanelPremium = React.forwardRef<HTMLDivElement, FilterPanelSlotProps>(
  function CustomFilterPanelPremium(props, ref) {
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const model = useGridSelector(apiRef, gridFilterModelSelector);
    const filterableColumns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);
    return (
      <FilterPanelBody
        ref={ref}
        {...FILTER_PANEL_PROPS}
        {...props}
        grid={{
          apiRef,
          model,
          filterableColumns,
          multipleColumns: !rootProps.disableMultipleColumnsFiltering,
          FilterForm: GridFilterForm,
          PanelWrapper: GridPanelWrapper,
          readOnlySupported: true,
        }}
      />
    );
  }
);

export default CustomFilterPanelPremium;
